import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage } from "@/context/LanguageContext";
import { cn } from "@/lib/utils";

export const LanguageSelector = ({ variant = "light", testId = "language-selector-dropdown" }) => {
  const { currentLanguage, setLanguage, languages } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={cn(
            "flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-medium transition-colors",
            variant === "light"
              ? "border-[#E2E8F0] text-[#042D1F] hover:bg-[#F2F9F5]"
              : "border-white/20 text-white/80 hover:text-white hover:bg-white/10"
          )}
        >
          <Globe className="h-4 w-4" />
          <span>{currentLanguage.code.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-72 w-48">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            data-testid={`language-option-${lang.code}`}
            onClick={() => setLanguage(lang.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className="flex flex-col">
              <span className="text-sm">{lang.label}</span>
              <span className="text-xs text-muted-foreground">{lang.native}</span>
            </span>
            {currentLanguage.code === lang.code && <Check className="h-4 w-4 text-[#0B4F37]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
